export enum Route {
    SetDefaultMailSender = "user-settings/set-default-mail-sender",
}